import React, { createContext, useContext, useEffect, useState } from 'react';

const FontContext = createContext({});

export const FontProvider = ({ children }) => {
  const [fontsLoaded, setFontsLoaded] = useState(true); // Web não precisa carregar fontes nativas

  // carrega fontes
  useEffect(() => {
    // Carregar fontes do Google Fonts
    const link = document.createElement('link');
    link.href = 'https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap';
    link.rel = 'stylesheet';
    document.head.appendChild(link);
    
    setFontsLoaded(true);
    
    return () => {
      document.head.removeChild(link);
    };
  }, []);

  return (
    <FontContext.Provider value={{ fontsLoaded }}>
      {fontsLoaded ? children : <div>Loading fonts...</div>}
    </FontContext.Provider>
  );
};

export const useFonts = () => useContext(FontContext);